import { mapGetters, mapActions } from 'vuex'
import { getMasterDataText } from '@/helpers'

export default {
  data () {
    return {
      isRenderTime: true,
      timer: null,
    }
  },
  computed: {
    ...mapGetters({
      queues: 'getPosQueues',
      orders: 'getPosOrders',
      getCustomerById: 'getCustomerById',
      posSettings: 'getPosSetting',
    }),
    mapQueues() {
      return this.queues.map((queue) => {
        return {
          ...queue,
          orderCount: this.orders.reduce((acc, cur) => {
            const order = cur
            if (order.queue_number == queue.queue_number) {
              acc += order.quantity
            }
            return acc
          }, 0),
        }
      })
    },
    refName () {
      return getMasterDataText(this.posSettings.table.ref_name, this.$t)
    },
  },
  mounted () {
    const that = this
    this.timer = setInterval(function() {
      that.isRenderTime = false
      that.$nextTick(function() {
        that.isRenderTime = true
      })
    }, 1000)
  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    ...mapActions({
      setPosSection: 'setPosSection',
      setPosSelectedQueue: 'setPosSelectedQueue',
    }),
    onSelectedQueue (queue_number) {
      this.setPosSelectedQueue(queue_number)
      this.setPosSection('choose-product')
    },
    getDiningText(diningName) {
      return getMasterDataText(diningName, this.$t)
    },
    getCustomerName (customerId) {
      const customer = this.getCustomerById(customerId)
      return customer ? customer.customer_name : null
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/pos/queueList.js